// Final wizard step (Activate) — name + channels + a backtest preview of the strategy
// selected in Discover + Save/Activate. Conditions were chosen by selecting a scan
// candidate, not hand-picked. Flat layout with dividers (bb-traderx style).

import { useState } from "react";
import { Input } from "@/components/ui/input";
import { ChannelSection } from "../ChannelSection";
import { ReviewBar } from "../ReviewBar";
import { BacktestSummary } from "../../backtest/BacktestSummary";
import { useBuilderState } from "../../../state/BuilderState";
import type { BacktestResponseDto } from "../../../api/types";

export function Step3Activate() {
  const { draft, patch } = useBuilderState();
  const [lastBacktest, setLastBacktest] = useState<BacktestResponseDto | null>(null);

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-3">
        <div>
          <h2 className="text-lg font-bold">Name & description</h2>
          <p className="text-xs text-muted-foreground mt-0.5">
            Internal display name — what you'll see in the Strategies tab.
          </p>
        </div>
        <Input
          value={draft.name}
          onChange={(e) => patch({ name: e.target.value })}
          placeholder="My BTC 1m RSI long+short"
          className="h-11 rounded-xl border-2"
        />
      </div>

      <div className="border-t border-border" />

      <ChannelSection />

      <div className="border-t border-border" />

      <div className="flex flex-col gap-3">
        <div>
          <h2 className="text-lg font-bold">Backtest preview</h2>
          <p className="text-xs text-muted-foreground mt-0.5">
            Optional — sanity-check the strategy on recent history. Persisted onto the strategy so the
            first webhook payload carries populated score / winRate / suggestedSL.
          </p>
        </div>
        <BacktestSummary
          result={lastBacktest}
          emptyText='Click "Run backtest" below to evaluate over the latest 5000 bars.'
        />
      </div>

      <ReviewBar lastBacktest={lastBacktest} onBacktestResult={setLastBacktest} />
    </div>
  );
}
